import React, { useState } from 'react';
import { Helmet } from "react-helmet";
import { breadcrumbSchemaJson } from "../../utils/breadcrumbSchema";
import { Link } from "react-router-dom";
import './GlobalStakeholder.css';

function GlobalStakeholder() {
  const [content, setContent] = useState(
    "At 360 SynergyTech, we transform businesses with custom software solutions, AI integrations, and cloud development services. Our expert team delivers <a href='/custom-software-development'>web development</a>, mobile apps, CRM solutions, and RPA automation to scale your operations efficiently. We help startups, enterprises, and real estate businesses automate, grow, and innovate."
  );
  const [activeItem, setActiveItem] = useState("about");

  const handleItemClick = (item) => {
    setActiveItem(item);
    if (item === "about") {
      setContent(
        "At 360 SynergyTech, we transform businesses with custom software solutions, AI integrations, and cloud development services. Our expert team delivers <a href='/custom-software-development'>web development</a>, mobile apps, CRM solutions, and RPA automation to scale your operations efficiently. We help startups, enterprises, and real estate businesses automate, grow, and innovate."
      );
    } else if (item === "mission") {
      setContent(
        "At 360 SynergyTech, our mission is to help businesses innovate with AI-powered solutions, custom <a href='/custom-software-development'>web development</a>, mobile apps, cloud application development, and automation services. We enable startups, enterprises, and real estate companies to automate processes, enhance digital experiences, and scale smarter. Partner with us today to future-proof your business."
      );
    } else if (item === "vision") {
      setContent(
        "At 360 SynergyTech, our vision is to be a global leader in AI solutions, <a href='/custom-software-development'>web development</a>, mobile apps, and cloud innovation. We aim to empower businesses with intelligent automation, seamless digital transformation, and scalable technologies that shape the future of industries. Discover how we drive innovation."
      );
    }
  };

  return (
    <>
      <Helmet>
      
        <title>About Us | 360 SynergyTech</title>
        <link rel="canonical" href="https://360synergytech.com/about" />

        <meta property="og:title" content="About Us | 360 SynergyTech" />
        <meta property="og:url" content="https://360synergytech.com/about" />
        <meta property="og:image" content="https://360synergytech.com/header111.jpg" />
        <meta property="og:description" content="Learn more about 360 SynergyTech, our mission, vision, and commitment to delivering innovative IT solutions for startups, enterprises, and industries worldwide." />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Us | 360 SynergyTech" />
        <meta name="twitter:description" content="Discover our journey, expertise, and dedication to technology excellence." />
        <meta name="twitter:image" content="https://360synergytech.com/header111.jpg" />

        
        <meta name="description" content="Learn who we are, what drives us, and how 360 SynergyTech helps companies grow with technology, AI, and cloud expertise." />
        
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "AboutPage",
              "name": "About 360 SynergyTech",
              "url": "https://360synergytech.com/about",
              "description": "Learn who we are, what drives us, and how 360 SynergyTech helps companies grow with technology, AI, and cloud expertise."
            }
          `}
        </script>
        <script type="application/ld+json">{breadcrumbSchemaJson([{ name: "About Us", path: "/about" }])}</script>
      </Helmet>
      <div className="main_div_GlobalStakeholder">
        <div className="container">
          <div className="row m-0 p-0 align-items-start">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <h1 style={{marginBottom: 0, textAlign: 'left'}}>
                <span className="globalheading_black">We Are Global Stakeholder Over 2000+</span>
                <span className="globalheading_blue"> Companies</span>
              </h1>
              <h2 className="para_global_heading" style={{marginTop: 16, fontWeight: 400, textAlign: 'left'}}>
                We build custom software, AI, cloud and data solutions for businesses.
              </h2>
              <ul style={{listStyle: 'none', padding: 0, marginTop: 24}}>
                <li style={{display: 'flex', alignItems: 'center', marginBottom: 16}}>
                  <div className="blue_round_div"><i className="fa fa-bullseye"></i></div>
                  <span className="circle_para_round">Custom software and AI solutions</span>
                </li>
                <li style={{display: 'flex', alignItems: 'center', marginBottom: 16}}>
                  <div className="blue_round_div"><i className="fa fa-bullseye"></i></div>
                  <span className="circle_para_round">Cloud and data engineering</span>
                </li>
                <li style={{display: 'flex', alignItems: 'center'}}>
                  <div className="blue_round_div"><i className="fa fa-bullseye"></i></div>
                  <span className="circle_para_round">Product strategy and design</span>
                </li>
              </ul>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="main_div_aboutus_mission_vision joined-tabs">
                <div
                  className={activeItem === "about" ? "orange_div_active joined_tab" : "blue_div_active joined_tab"}
                  onClick={() => handleItemClick("about")}
                >
                  About Us
                </div>
                <div
                  className={activeItem === "mission" ? "orange_div_active joined_tab" : "blue_div_active joined_tab"}
                  onClick={() => handleItemClick("mission")}
                >
                  Mission
                </div>
                <div
                  className={activeItem === "vision" ? "orange_div_active joined_tab" : "blue_div_active joined_tab"}
                  onClick={() => handleItemClick("vision")}
                >
                  Vision
                </div>
              </div>
              <div className="show_content" style={{marginTop: 24, textAlign: 'left'}}
                dangerouslySetInnerHTML={{ __html: content }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default GlobalStakeholder;